// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__NjqW_","rows":"style_rows__1RCdu","row":"style_row__3b1TB","subtitle":"style_subtitle__3tQDs","grid":"style_grid__3g7Ds"};